import { EOfferExtensionType } from '../../types/offer';
import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const geoExtensionLabel: TComputedPropMapper<string | undefined> = ({ offer }) => {
  const extension = (offer.extensionLabels || []).find(
    extension => extension.labelType === EOfferExtensionType.Outskirts,
  );

  return extension && extension.value;
};
